import React, { useState, useEffect ,useRef} from 'react'
import { AiOutlinePlusCircle, AiOutlineDelete } from 'react-icons/ai';
import axios from 'axios'
import { useNavigate } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';
import ToastNotification from '../../components/ToastNotification';
import { MdEdit } from "react-icons/md";
import { FaEye } from "react-icons/fa";
import Select from 'react-select';
import { FaWhatsapp } from "react-icons/fa6";
import { BsBank2 } from "react-icons/bs";
import { useLocation } from 'react-router-dom';



const Accounts = ({adminData}) => {
    const navigate = useNavigate();
    const formRef = useRef();

    const [filterField, setFilterField] = useState('');
    const [filterValue, setFilterValue] = useState('');
    const [filteredDetail, setFilteredDetail] = useState([]);
    const [showAddForm, setShowAddForm] = useState(false);
    const [detail, setDetail] = useState([])
    const [parent, setParent] = useState([]);
    const [showConfirm, setShowConfirm] = useState(false);
    const [editingCompanyId, setEditingCompanyId] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [accountDetail, setAccountDetail] = useState([]);
    const [deleteId, setDeleteId] = useState(null);
    const [accountType, setAccountType] = useState([]);
    const [type, setType] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    const getAccountTypeName = (typeVal) => {
        if (!typeVal) return "-";
        const found = accountType.find(at => String(at.id) === String(typeVal) || at.type_acc === typeVal);
        return found ? found.type_acc : typeVal;
    };

    const handleView = (acc) => {
        navigate("/admin/party", {
            state: {
                mode: "isEditMode",
                partyId: acc.party_id,
                accountId: acc.id,
                accountcode: acc.code,
                accountData: acc,
                from: "accounts"
            }
        });
    };

    // add party state
    const [source, setSource] = useState([]);
    const [fetchAccountType, setFetchAccoutnType] = useState([]);
    const [profession, setProfession] = useState([]);
    const [typeProfessin, setTypeProfession] = useState([]);
    const [postOneOptions, setPostOneOptions] = useState([]);
    const [postTwoOptions, setPostTwoOptions] = useState([]);
    const [postThreeOptions, setPostThreeOptions] = useState([]);
    const [showPostModal, setShowPostModal] = useState(false);
    const [newPostName, setNewPostName] = useState("");
    const [activePostField, setActivePostField] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showPartyForm, setShowPartyForm] = useState(false);
    const [coords, setCoords] = useState({ latitude: null, longitude: null });
     const [partyMaster, setPartyMaster] = useState([]);
const [partyTypeOptions, setPartyTypeOptions] = useState([]);

    const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
    const showToast = (msg, bg = 'success') => {
        setToast({ show: true, message: msg, bg });
    };


    const [newProduct, setNewProduct] = useState({
        partyId: "",
        name: "",
        type: "",
        holder_name: '',
        code: '',
        type_account: '',
        parent: '',
        op_bal: '',
        budget: '',
        days: '',
        party_id: "",
        isAccountChecked: true,
    });



    const [partyData, setPartyData] = useState({
        name: '',
        parent: '',
        address: "",
        landmark: '',
        city: "",
        pin: '',
        phone: '',
        email: '',
        priority: '',
        type: '',
        remark: '',
        state: '',
        region: '',
        birth: '',
        fax: '',
        mobile: '',
        pan: '',
        gst: '',
        profession: '',
        source: '',
        prodct: '',
        phoneChecked_two: '',
        phone_three: '',
        profession_type: '',
        contact_name: '',
        contact_no: '',
        currentAdd: '',
        post_one: '',
        post_two: '',
        post_three: '',
        // isAccountChecked: true,
        phoneChecked_one: false,
        phoneChecked: false,
        phoneChecked_two: false,
        phoneChecked_three: false,
        phoneChecked_contact: false,
        type_account: '',
        customer_type: '',
        account_code: '',

        cin: '',
        msme: '',


    })


    useEffect(() => {

        const lowerSearch = filterValue.toLowerCase();

        const filtered = accountDetail.filter(
            (item) =>
                item.holder_name?.toLowerCase().includes(lowerSearch) ||
                item.budget?.toLowerCase().includes(lowerSearch) ||
                item.code?.toLowerCase().includes(lowerSearch) ||
                item.phone?.toLowerCase().includes(lowerSearch)
        );

        setFilteredDetail(filtered);

    }, [filterValue, detail]);


    const handleAddClick = () => {
        setNewProduct((prev) => ({
            ...prev,
            name: prev.holder_name
        }));


        setShowPartyForm(true);
    }

    const handleDeleteClick = (id) => {
        setDeleteId(id);
        setShowConfirm(true);
    };

    const confirmDelete = () => {
        handleDelete(deleteId);
        setShowConfirm(false);
    };




    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewProduct(prev => ({ ...prev, [name]: value }));
    };

  

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!newProduct.holder_name) {
            showToast("Please enter Account Holder Name", "danger");
            return;
        }

        if (isEditMode) {
  
            try {
                await axios.put(
                    `https://api.skyguard.group/api/update-account/${newProduct.id}`,
                    newProduct
                );

                showToast('Account updated successfully!', 'success');
                fecthAccountDetail();
                setShowAddForm(false);

            } catch (error) {
                showToast('Fail to update account!', 'danger');
            }

        } else {
            try {

                let partyId = null;

              

if (newProduct.isAccountChecked) {

  const partyPayload = new FormData();

  const partyFields = [
    "name", "parent", "address", "landmark", "city", "pin",
    "phone", "email", "priority", "type", "remark", "state",
    "region", "birth", "fax", "mobile", "pan", "gst",
    "profession", "source", "product",
    "phone_two", "phone_three",
    "profession_type", "contact_name", "contact_no",
    "currentAdd", "post_one", "post_two", "post_three",
    "customer_type", "cin", "msme"
  ];

  partyFields.forEach((field) => {
    const value = newProduct[field];
    if (value !== undefined && value !== null && value !== "") {
      partyPayload.append(field, String(value));
    }
  });

  partyPayload.set("name", newProduct.holder_name);
  partyPayload.append("add_by_id", adminData.user.id);

  if (files.file) {
    partyPayload.append("file", files.file);
  }

  if (files.video) {
    partyPayload.append("video", files.video);
  }

  const partyRes = await axios.post(
    "https://api.skyguard.group/api/add-party",
    partyPayload
  );


  console.log("Party Response:", partyRes.data);

  if (partyRes.status === 200) {
    // partyId = partyRes.data.id;
    // partyId = partyRes.data.resultadd[0];
    partyId = partyRes.data.id;
  }
}
                const accountPayload = {
                    ...newProduct,
                    party_id: partyId
                };

                await axios.post(
                    "https://api.skyguard.group/api/add-account",
                    accountPayload
                );

                showToast("Account added successfully!", 'success');
                fecthAccountDetail();
                setShowAddForm(false);

                // reset
                setNewProduct({
                    party_id: "",
                    name: "",
                    type: "",
                    holder_name: '',
                    code: '',
                    type_account: '',
                    parent: '',
                    op_bal: '',
                    budget: '',
                    days: '',
                    isAccountChecked: false
                });

            } catch (error) {
                // console.error(error);
                // showToast("Error adding account", 'danger');
                console.error("ACCOUNT ERROR:", error?.response?.data || error.message);
  showToast(
    error?.response?.data?.message || "Error adding account",
    "danger"
  );
            }
        }
    };


    const fecthAccountDetail = async () => {
        try {
            const resParty = await axios.get('https://api.skyguard.group/api/fetch-account');
            const result = resParty.data.result;
            // setParent(result);
            // setAccountDetail(result); 

            const sortedData = [...result].sort((a, b) => b.id - a.id); // DESC

            setParent(sortedData);
            setAccountDetail(sortedData);
        } catch (error) {
            console.log(error)
        }
    };


    useEffect(() => {
        fecthAccMasterDetail();
        fecthAccountDetail();
    }, []);


    const handleDelete = async (id) => {
        try {
            const res = await axios.delete(`https://api.skyguard.group/api/delete-account/${id}`);
            showToast('Account deleted successfuly!', 'success');

            fecthAccountDetail();
        } catch (error) {
            console.error("❌ Error deleting:", error.response?.data || error.message);
            showToast("Failed to delete Account", 'danger');
        }
    };



    const handleEdit = (form) => {

        setNewProduct({
            id: form.id || '',
            name: form.name || "",
            type: form.type || "",
            holder_name: form.holder_name || '',
            code: form.code || '',
            type_account: form.type_account || '',
            parent: form.parent || '',
            op_bal: form.op_bal || '',
            budget: form.budget || '',
            days: form.days || ''
        });
        setEditingCompanyId(form.id);
        setIsEditMode(true);
        setShowAddForm(true);
    };


    const fecthAccMasterDetail = async () => {

        try {
            const resParty = await axios.get('https://api.skyguard.group/api/fetch-acc-master');
            setAccountType(resParty.data.result);
            const uniqueTypes = [...new Set(resParty.data.result.map(item => item.type_acc))];

            const typeOptions = uniqueTypes.map(t => ({
  value: t,
  label: t
}));

            setType(uniqueTypes);

             const uniqueTypesAccount = [...new Set(resParty.data.result.map(item => item.type_acc))];
            setFetchAccoutnType(uniqueTypesAccount);  
        } catch (error) {
            console.log(error)
        }
    };



    const filterAccount = accountDetail.filter((tt) => {
        const term = (searchTerm || "").toLowerCase();

        return (
            (tt.holder_name && tt.holder_name.toLowerCase().includes(term)) ||
            (tt.type_account && tt.type_account.toLowerCase().includes(term)) ||
            (tt.code && tt.code.toLowerCase().includes(term)) ||
            (tt.party_phone && tt.party_phone.toLowerCase().includes(term)) ||
            (tt.party_mobile && tt.party_mobile.toLowerCase().includes(term)) ||
            (tt.phone_two && tt.phone_two.toLowerCase().includes(term)) ||
            (tt.phone_three && tt.phone_three.toLowerCase().includes(term))
        );
    });

    // add party

    const [files, setFiles] = useState({
        file: null,
        video: null

    })


    const handleVideoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const fileSizeInMB = file.size / (1024 * 1024);
            if (fileSizeInMB > 5) {
                showToast("Video size is too large! Please upload a video smaller than 5MB.", 'danger');
                return;
            }
            setFiles((prev) => ({
                ...prev,
                [e.target.name]: file,
            }));
        }
    };


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const fileSizeInMB = file.size / (1024 * 1024);
            if (fileSizeInMB > 2) {
                showToast("File size is too large! Please upload a file smaller than 2MB.", 'danger');
                return;
            }
            setFiles({ ...files, [e.target.name]: file });
        }
    };

    const priorityOptions = [
        { value: '1', label: 'High' },
        { value: '2', label: 'Medium' },
        { value: '3', label: 'Normal' },
    ]


    const handlePincodeCheck = async () => {
        try {
            const response = await axios.get(
                `https://api.skyguard.group/api/check?pincode=${newProduct.pin}`
            );
            const data = response.data;
            setNewProduct({
                ...newProduct,
                city: data.city,
                state: data.state,
                region: data.region
            });
        } catch (error) {


            if (error.response && error.response.status === 404) {
                showToast("❌ Pincode not found !", 'danger');
            } else {
                showToast("⚠️ Something went wrong while checking the pincode.", 'danger');
            }
            console.error("Error checking pincode:", error);
            setNewProduct({
                ...newProduct,
                city: "",
                state: "",
                region: ""
            });
        }
    };


    const getCurrentLoc = () => {
        if (!navigator.geolocation) {
            console.error("Geolocation is not supported by your browser.");
            return;
        }

        setLoading(true);
        navigator.geolocation.getCurrentPosition(
            async (position) => {
                const { latitude, longitude } = position.coords;

                setCoords({ latitude, longitude });

                try {
                    const response = await fetch(
                        `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
                    );
                    const data = await response.json();
                    setLoading(false);
                    if (data && data.display_name) {
                        setNewProduct((prev) => ({
                            ...prev,
                            currentAdd: data.display_name,
                        }));
                    } else {

                        setNewProduct((prev) => ({
                            ...prev,
                            currentAdd: "Address not found",
                        }));
                    }
                } catch (error) {
                    console.error("Error fetching address:", error);
                    setLoading(false);
                }
            },
            (err) => {
                console.error("Geolocation error:", err);
            }
        );
    };

    const handlePostChange = (e, field) => {
        if (e.target.value === "__add_new_post__") {
            setActivePostField(field);
            setShowPostModal(true);
        } else {
            setNewProduct({ ...newProduct, [field]: e.target.value });
        }
    };

      useEffect(() => {
        const fecthDetail = async () => {
    
          try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-master-party');
            setPartyMaster(res.data.result);
            const uniqueTypes = [
              ...new Set(res.data.result.map((item) => item.type)),
            ];
            const typeOptions = uniqueTypes.map((t) => ({
              value: t,
              label: t,
            }));

            // setType(typeOptions)

            setPartyTypeOptions(typeOptions); 
            const uniqueProfession = [
              ...new Set(res.data.result.map((item) => item.profession)),
            ];
            const professionOptions = uniqueProfession.map((p) => ({
              value: p,
              label: p,
            }));
            setProfession(professionOptions)
            const uniqueProfessionType = [
              ...new Set(res.data.result.map((item) => item.type_profession)),
            ];
            const professionTypeOptions = uniqueProfessionType.map((pt) => ({
              value: pt,
              label: pt,
            }));
    
            setTypeProfession(professionTypeOptions)
            const uniqueSource = [
              ...new Set(res.data.result.map((item) => item.source)),
            ];
            const sourceOptions = uniqueSource.map((s) => ({
              value: s,
              label: s,
            }));
    
            setSource(sourceOptions)
          } catch (error) {
            console.log(error)
          }
        };
        fecthDetail();
      }, []);


      
    return (
        <div className='main-section'>
            <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                <h3 className='my-3 fw-bold fs-5 golos'>Accounts</h3>
                <ToastNotification
                    show={toast.show}
                    message={toast.message}
                    bg={toast.bg}
                    onClose={() => setToast({ ...toast, show: false })}
                />

                <div className="mb-3 row gx-2 gy-2 d-flex justify-content-between">


                    <div class="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">

                        <div class="col-12 col-md-9">
                            <div className="row my-3 align-items-center">
                                {/* Input */}
                                <div className="col-md-4">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search By name,type number"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-2 d-flex justify-content-end">
                            <button
                                className={`btn ${showAddForm ? 'btn-danger' : 'btn-success'}`}
                                onClick={() => {
                                    setShowAddForm(!showAddForm);
                                    if (showAddForm) {

                                    }
                                }}
                            >
                                {showAddForm ? 'Cancel' : 'Add'}{' '}
                                {showAddForm ? <FaTimes size={18} /> : <AiOutlinePlusCircle size={20} />}
                            </button>
                        </div>

                    </div>
                </div>

                {showAddForm && (
                    <div className='card p-3 mb-4'  ref={formRef}>
                        <h5 className="mb-3">Add New Account</h5>
                        <form className='row g-3' onSubmit={handleSubmit} >

                            {isEditMode && (
                                <div className="mb-3">

                                    <span className="badge bg-primary px-3 py-2">
                                        {newProduct.holder_name}
                                    </span>
                                </div>
                            )}

                            <div className='col-md-4'>
                                <label>Account Holder Name</label>
                                <input
                                    type="text"
                                    className="form-control"

                                    name="holder_name"
                                    value={newProduct.holder_name}
                                    onChange={handleInputChange}
                                />
                            </div>

                            <div className="col-md-4">
                                <label>Type Of Account</label>
                                <select
                                    className="form-control"
                                    name="type_account"
                                    value={newProduct.type_account}
                                    onChange={handleInputChange}
                                >
                                    <option value="">-- Select Type --</option>
                                    {type.map((t, index) => (
                                        <option key={index} value={t}>
                                            {t}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className='col-md-4'>
                                <label>Parent Name</label>
                                <select
                                    className='form-control'
                                    name='parent'
                                    value={newProduct.parent}
                                    onChange={handleInputChange}
                                >
                                    <option value=''>Select Parent...</option>
                                    {parent.map((p, index) => (
                                        <option key={index} value={p.id}>
                                            {p.holder_name}
                                        </option>
                                    ))}
                                </select>
                            </div>



                            <div className="col-md-4">
                                <laebl>Op. Bal</laebl>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="op_bal"
                                    value={newProduct.op_bal}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="col-md-4">
                                <laebl>Limit/Budget</laebl>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="budget"
                                    value={newProduct.budget}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="col-md-4">
                                <laebl>Days</laebl>
                                <input
                                    type="text"
                                    className="form-control"

                                    name="days"
                                    value={newProduct.days}
                                    onChange={handleInputChange}
                                />
                            </div>

                            {!isEditMode && (
                             <>
                               <div className="col-md-4 ">

                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={newProduct.isAccountChecked}
                                    onChange={(e) =>
                                        setNewProduct({
                                            ...newProduct,
                                            isAccountChecked: e.target.checked,
                                        })
                                    }
                                    id="phoneCheckbox"
                                />
                                <label className="form-check-label small fw-bold bg-danger px-2 py-1 rounded mx-2 text-white" htmlFor="phoneCheckbox">
                                    Are you want to create a party as well ??
                                </label>
                            </div>

                            <div className="col-md-4">
                                <button type='button' className='btn btn-primary' onClick={handleAddClick} >Add Party </button>
                            </div>
                             </>
                            )}

                           


                            {showPartyForm && (
                                <>
                                    <div className="card mt-3 shadow-sm" style={{ backgroundColor: "#d4e6f9" }}>


                                        <div className='card-body'>
                                            <div >
                                                <div className='row g-3'>



                                                    <div className="mb-0   bold">
                                                        <h5 className="btn btn-primary btn-sm rounded-pill d-inline-block fw-bold px-3 py-2">
                                                            Basic Detail
                                                        </h5>
                                                    </div>

                                                    <div className='col-md-4'>
                                                        <label>Party Name</label>
                                                        <input
                                                            type='text'
                                                            className='form-control'
                                                            name='name'
                                                            value={newProduct.name}
                                                            placeholder='Party Name'
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                    </div>

                                                    {/* <div className='col-md-4'>
             <label>Account Code</label>
           
               <input 
                 type='text'
                 className='form-control'
                 value={accountCode}
                 disabled
               />
           </div> */}



                                                    <div className='col-md-4'>
                                                        <label>Parent Name</label>

                                                        <select
                                                            className="form-control"
                                                            name="parent"
                                                            value={newProduct.parent}
                                                            onChange={handleInputChange}

                                                        >
                                                            <option value="">Select Parent...</option>


                                                            {parent.map((p, index) => (
                                                                <option key={index} value={p.id}>
                                                                    {p.name}
                                                                </option>
                                                            ))}
                                                        </select>

                                                    </div>




                                                    <div className='col-md-4'>
                                                        <label>Landmark</label>
                                                        <input
                                                            type='text'
                                                            className='form-control'
                                                            name='landmark'
                                                            value={newProduct.landmark}
                                                            placeholder='Landmark'
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>



                                                    <div className='col-md-4 '>

                                                        <div className="d-flex align-items-end gap-2">


                                                            <div className='flex-grow-1 '>
                                                                <label>Pincode</label>


                                                                <input
                                                                    type='number'
                                                                    className='form-control'
                                                                    name='pin'
                                                                    value={newProduct.pin}
                                                                    placeholder='Pincode'
                                                                    onChange={handleInputChange}

                                                                    required
                                                                />
                                                            </div>

                                                            <button className='btn btn-primary'
                                                                type="button"
                                                                onClick={handlePincodeCheck}
                                                            >OK </button>
                                                        </div>
                                                    </div>




                                                    <div className='col-md-4'>
                                                        <label>State</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="state"
                                                            value={newProduct.state}
                                                            readOnly
                                                        />
                                                    </div>

                                                    <div className='col-md-4'>
                                                        <label>City</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="city"
                                                            value={newProduct.city}
                                                            readOnly
                                                        />
                                                    </div>

                                                    <div className='col-md-4'>
                                                        <label>Region</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="region"
                                                            value={newProduct.region}
                                                            readOnly
                                                        />
                                                    </div>




                                                    <div className='col-md-4'>
                                                        <label>Phone No.</label>
                                                        <input
                                                            type='tel'
                                                            className='form-control'
                                                            name='phone'
                                                            value={newProduct.phone}
                                                            placeholder='Phone'
                                                            onChange={handleInputChange}
                                                            maxLength={10}
                                                            required
                                                        />

                                                        <div className="d-flex justify-content-between align-items-center">


                                                            {/* Checkbox inside label row */}
                                                            <div className="form-check mb-0">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id="phoneCheckbox"
                                                                    checked={newProduct.phoneChecked_one}
                                                                    onChange={(e) => setNewProduct({ ...newProduct, phoneChecked_one: e.target.checked })}
                                                                />
                                                                <FaWhatsapp size={20} className='text-success' />
                                                            </div>

                                                        </div>

                                                    </div>

                                                    <div className='col-md-4'>
                                                        <label>Alternate Number First.</label>
                                                        <input
                                                            type='tel'
                                                            className='form-control'
                                                            name='mobile'
                                                            value={newProduct.mobile}
                                                            placeholder='Mobile'
                                                            onChange={handleInputChange}
                                                            maxLength={10}

                                                        />

                                                        <div className="d-flex justify-content-between align-items-center">



                                                            <div className="form-check mb-0">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id="phoneCheckbox"
                                                                    checked={newProduct.phoneChecked}
                                                                    onChange={(e) => setNewProduct({ ...newProduct, phoneChecked: e.target.checked })}
                                                                />
                                                                <FaWhatsapp size={20} className='text-success' />
                                                                <label className="form-check-label small" htmlFor="phoneCheckbox">

                                                                </label>
                                                            </div>

                                                        </div>

                                                    </div>



                                                    <div className="col-md-4">
                                                        <label>Post 1</label>
                                                        <select
                                                            className="form-control"
                                                            name="post_one"
                                                            value={newProduct.post_one}
                                                            onChange={(e) => handlePostChange(e, "post_one")}
                                                        >
                                                            <option value="">-- Select Post 1 --</option>
                                                            {postOneOptions.map((p, i) => <option key={i} value={p}>{p}</option>)}
                                                            <option value="__add_new_post__">➕ Add New Post</option>
                                                        </select>

                                                    </div>


                                                    {showPostModal && (
                                                        <div className="modal show d-block" tabIndex="-1">
                                                            <div className="modal-dialog">
                                                                <div className="modal-content">
                                                                    <div className="modal-header">
                                                                        <h5 className="modal-title">Add New Post</h5>
                                                                        <button className="btn-close" onClick={() => setShowPostModal(false)}></button>
                                                                    </div>
                                                                    <div className="modal-body">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            value={newPostName}
                                                                            onChange={(e) => setNewPostName(e.target.value)}
                                                                        />
                                                                    </div>
                                                                    <div className="modal-footer">
                                                                        <button
                                                                            className="btn btn-secondary"
                                                                            onClick={() => {
                                                                                setShowPostModal(false);
                                                                                setNewPostName("");
                                                                            }}
                                                                        >
                                                                            Cancel
                                                                        </button>
                                                                        <button
                                                                            className="btn btn-success"
                                                                            onClick={() => {
                                                                                if (!newPostName.trim()) return;

                                                                                // Add to correct post options
                                                                                if (activePostField === "post_one") {
                                                                                    setPostOneOptions([...postOneOptions, newPostName]);
                                                                                } else if (activePostField === "post_two") {
                                                                                    setPostTwoOptions([...postTwoOptions, newPostName]);
                                                                                } else if (activePostField === "post_three") {
                                                                                    setPostThreeOptions([...postThreeOptions, newPostName]);
                                                                                }

                                                                                // Set selected value
                                                                                setNewProduct({ ...newProduct, [activePostField]: newPostName });

                                                                                // Reset
                                                                                setNewPostName("");
                                                                                setShowPostModal(false);
                                                                            }}
                                                                        >
                                                                            OK
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}




                                                    <div className='col-md-4'>
                                                        <label>Alternate Number Second </label>
                                                        <input
                                                            type='tel'
                                                            className='form-control'
                                                            name='phone_two'
                                                            value={newProduct.phone_two}
                                                            placeholder='Phone'
                                                            onChange={handleInputChange}
                                                            maxLength={10}
                                                        />


                                                        <div className="d-flex justify-content-between align-items-center">


                                                            {/* Checkbox inside label row */}
                                                            <div className="form-check mb-0">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id="phoneCheckbox"
                                                                    checked={newProduct.phoneChecked_two}
                                                                    onChange={(e) => setNewProduct({ ...newProduct, phoneChecked_two: e.target.checked })}
                                                                />
                                                                <FaWhatsapp size={20} className='text-success' />
                                                            </div>
                                                        </div>


                                                    </div>



                                                    <div className="col-md-4">
                                                        <label>Post 2</label>



                                                        <select
                                                            className="form-control"
                                                            name="post_two"
                                                            value={newProduct.post_two}
                                                            onChange={(e) => handlePostChange(e, "post_two")}
                                                        >
                                                            <option value="">-- Select Post 2 --</option>
                                                            {postTwoOptions.map((p, i) => <option key={i} value={p}>{p}</option>)}
                                                            <option value="__add_new_post__">➕ Add New Post</option>
                                                        </select>

                                                    </div>


                                                    <div className='col-md-4'>
                                                        <label>Alternate Number Third</label>
                                                        <input
                                                            type='tel'
                                                            className='form-control'
                                                            name='phone_three'
                                                            value={newProduct.phone_three}
                                                            placeholder='Phone'
                                                            onChange={handleInputChange}
                                                            maxLength={10}
                                                        />

                                                        <div className="d-flex justify-content-between align-items-center">


                                                            {/* Checkbox inside label row */}
                                                            <div className="form-check mb-0">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id="phoneCheckbox"
                                                                    checked={newProduct.phoneChecked_three}
                                                                    onChange={(e) => setNewProduct({ ...newProduct, phoneChecked_three: e.target.checked })}
                                                                />
                                                                <FaWhatsapp size={20} className='text-success' />
                                                            </div>
                                                        </div>

                                                    </div>


                                                    <div className="col-md-4">
                                                        <label>Post 3</label>


                                                        <select
                                                            className="form-control"
                                                            name="post_three"
                                                            value={newProduct.post_three}
                                                            onChange={(e) => handlePostChange(e, "post_three")}
                                                        >
                                                            <option value="">-- Select Post 3 --</option>
                                                            {postThreeOptions.map((p, i) => <option key={i} value={p}>{p}</option>)}
                                                            <option value="__add_new_post__">➕ Add New Post</option>
                                                        </select>

                                                    </div>

                                                    <div className='col-md-4'>
                                                        <label>Email</label>
                                                        <input
                                                            type='email'
                                                            className='form-control'
                                                            name='email'
                                                            value={newProduct.email}
                                                            placeholder='Email'
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                    </div>

                                                    <div className="col-md-4">
                                                        <label>Customer Type</label>
                                                        <select className="form-control"
                                                            name="customer_type"
                                                            value={newProduct.customer_type}
                                                            onChange={handleInputChange}
                                                            required
                                                        >
                                                            <option value="">Select Customer Type</option>
                                                            <option value="vendor">Vendor</option>
                                                            <option value="retailer">Retailer</option>
                                                        </select>
                                                    </div>





                                                    <div className='col-md-4'>
                                                        <label>Address</label>

                                                        <textarea
                                                            className="form-control"
                                                            name="address"
                                                            placeholder="Enter here..."
                                                            value={newProduct.address}
                                                            onChange={handleInputChange}
                                                            rows={4}
                                                        />
                                                    </div>



                                                    <div className='col-md-4'>
                                                        <label>Add Location</label>

                                                        <textarea
                                                            className="form-control"
                                                            name="currentAdd"
                                                            placeholder="Enter here..."
                                                            value={newProduct.currentAdd}

                                                            onChange={(e) =>
                                                                setNewProduct((prev) => ({ ...prev, currentAdd: e.target.value }))
                                                            }
                                                            rows={4}
                                                        />


                                                        <button
                                                            type="button"
                                                            className="btn btn-primary mt-2"
                                                            onClick={getCurrentLoc}
                                                        >
                                                            Use Current Location
                                                        </button>
                                                    </div>

                                                    <div className="mb-0   bold">
                                                        <h5 className="btn btn-primary btn-sm rounded-pill d-inline-block fw-bold px-3 py-2">
                                                            Other Detail
                                                        </h5>
                                                    </div>


                                                    <div className='col-md-4'>
                                                        <label>Contact Person Name</label>
                                                        <input
                                                            type='text'
                                                            className='form-control'
                                                            name='contact_name'
                                                            value={newProduct.contact_name}
                                                            placeholder='Contact Person Name'
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>

                                                    <div className='col-md-4'>
                                                        <label>Contact Person Number</label>
                                                        <input
                                                            type='tel'
                                                            className='form-control'
                                                            name='contact_no'
                                                            value={newProduct.contact_no}
                                                            placeholder='Contact Person Number'
                                                            onChange={handleInputChange}
                                                            maxLength={10}
                                                        />

                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div className="form-check mb-0">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id="phoneCheckbox"
                                                                    checked={newProduct.phoneChecked_contact}
                                                                    onChange={(e) => setNewProduct({ ...newProduct, phoneChecked_contact: e.target.checked })}
                                                                />
                                                                <FaWhatsapp size={20} className='text-success' />
                                                            </div>
                                                        </div>

                                                    </div>






                                                    <div className='col-md-4'>
                                                        <laebl>Pan</laebl>
                                                        <input
                                                            type='text'
                                                            className='form-control'
                                                            name='pan'
                                                            value={newProduct.pan}
                                                            placeholder='Pan'
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <label>GST No</label>
                                                        <input
                                                            type='text'
                                                            className='form-control'
                                                            name='gst'
                                                            value={newProduct.gst}
                                                            placeholder='GST'
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>


                                                    <div className='col-md-4'>
                                                        <label>CIN No</label>
                                                        <input
                                                            type='text'
                                                            className='form-control'
                                                            name='cin'
                                                            value={newProduct.cin}
                                                            placeholder='CIN No'
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>

                                                    <div className='col-md-4'>
                                                        <label>MSME</label>
                                                        <input
                                                            type='text'
                                                            className='form-control'
                                                            name='msme'
                                                            value={newProduct.msme}
                                                            placeholder='MSME No'
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <label>Priority</label>

                                                        <Select
                                                            options={priorityOptions}
                                                            placeholder="Choose Priority..."
                                                            id="Priority"
                                                            value={priorityOptions.find(option => option.label === newProduct.priority)}
                                                            onChange={(selectedOption) =>
                                                                setNewProduct({ ...newProduct, priority: selectedOption.label })
                                                            }
                                                        />
                                                    </div>

                                                    <div className='col-md-4'>
                                                        <label htmlFor="type-select">Sector:</label><br />
                                                        {/* <Select
                                                            options={type}
                                                            placeholder="Choose Sector ..."
                                                            id="type"
                                                            value={type.find((opt) => opt.value === newProduct.type) || null}
                                                            onChange={(selectedOption) =>
                                                                setNewProduct({ ...newProduct, type: selectedOption.value, }) // reset role when dept changes
                                                            }
                                                        /> */}

                                                        <Select
  options={partyTypeOptions}
  placeholder="Choose Sector ..."
  value={
    partyTypeOptions.find(
      (opt) => opt.value === newProduct.type
    ) || null
  }
  onChange={(selectedOption) =>
    setNewProduct({
      ...newProduct,
      type: selectedOption.value,
    })
  }
/>

                                                    </div>





                                                    <div className='col-md-4'>
                                                        <laebl>Product Category</laebl>


                                                        <Select
                                                            options={profession}
                                                            placeholder="Choose Product Category..."
                                                            id="profession"
                                                            value={profession.find((opt) => opt.value === newProduct.profession) || null}
                                                            onChange={(selectedOption) =>
                                                                setNewProduct({ ...newProduct, profession: selectedOption.value, })
                                                            }
                                                        />

                                                    </div>

                                                    <div className='col-md-4'>
                                                        <laebl>Type of  Profession</laebl>

                                                        <Select
                                                            options={typeProfessin}
                                                            placeholder="Choose Type ..."
                                                            id="typeProfessin"
                                                            value={typeProfessin.find((opt) => opt.value === newProduct.profession_type) || null}
                                                            onChange={(selectedOption) =>
                                                                setNewProduct({ ...newProduct, profession_type: selectedOption.value, })
                                                            }
                                                        />
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <laebl>Source</laebl>
                                                        <Select
                                                            options={source}
                                                            placeholder="Choose Type ..."
                                                            id="source"
                                                            value={source.find((opt) => opt.value === newProduct.source) || null}
                                                            onChange={(selectedOption) =>
                                                                setNewProduct({ ...newProduct, source: selectedOption.value, })
                                                            }
                                                        />
                                                    </div>

                                                    <div className='col-md-4'>
                                                        <laebl>Source of Product </laebl>
                                                        <input
                                                            type='text'
                                                            className='form-control'
                                                            name='product'
                                                            value={newProduct.product}
                                                            placeholder='Source Of Product'
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>




                                                    <div className='col-md-4'>
                                                        <laebl>Birth Day</laebl>
                                                        <input
                                                            type='date'
                                                            className='form-control'
                                                            name='birth'
                                                            value={newProduct.birth}
                                                            placeholder='Birth Day'
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <laebl>Fax</laebl>
                                                        <input
                                                            type='text'
                                                            className='form-control'
                                                            name='fax'
                                                            value={newProduct.fax}
                                                            placeholder='Fax'
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>

                                                    <div className='col-md-4'>
                                                        <laebl>Remark</laebl>

                                                        <textarea
                                                            className="form-control"
                                                            name="remark"
                                                            placeholder="Enter here..."
                                                            value={newProduct.remark}
                                                            onChange={handleInputChange}
                                                            rows={4}
                                                        />
                                                    </div>
                                                    <hr />

                                                    {/* <div className="form-check mb-0">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            checked={newProduct.isAccountChecked}
                                                            onChange={(e) =>
                                                                setNewProduct({
                                                                    ...newProduct,
                                                                    isAccountChecked: e.target.checked,
                                                                })
                                                            }
                                                            id="phoneCheckbox"
                                                        />
                                                        <label className="form-check-label small" htmlFor="phoneCheckbox">
                                                            Create Account
                                                        </label>
                                                    </div> */}


                                                    {newProduct.isAccountChecked && (
                                                        <div className="col-md-4">
                                                            <label>Type Of Account</label>
                                                            <select
                                                                className="form-control"
                                                                name="type_account"
                                                                value={newProduct.type_account}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="">-- Select Type --</option>
                                                                {fetchAccountType.map((t, index) => (
                                                                    <option key={index} value={t.trim()}>
                                                                        {t.trim()}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    )}


                                                    <div className="mb-0  bold">
                                                        <h5 className="btn btn-primary btn-sm rounded-pill d-inline-block fw-bold px-3 py-2">
                                                            Upload Document
                                                        </h5>
                                                    </div>

                                                    <div className='col-md-4'>
                                                        <label>Upload File</label>
                                                        {isEditMode && files.file && typeof files.file === "string" && (
                                                            <div style={{ marginBottom: 10 }}>
                                                                <span>Previous file: </span>
                                                                <a
                                                                    href={`https://api.skyguard.group/uploads/${files.file}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                >
                                                                    {files.file}
                                                                </a>
                                                            </div>
                                                        )}
                                                        <input type="file" className="form-control" name="file" accept="image/*,application/pdf" onChange={handleFileChange} />
                                                    </div>


                                                    <div className='col-md-4'>
                                                        <label>Upload Video</label>
                                                        {isEditMode && files.video && typeof files.video === "string" && (
                                                            <div style={{ marginBottom: 10 }}>
                                                                <span>Previous Video: </span>
                                                                <a
                                                                    href={`https://api.skyguard.group/uploads/${files.video}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                >
                                                                    {files.video}
                                                                </a>
                                                            </div>
                                                        )}
                                                        <input
                                                            type="file"
                                                            className="form-control"
                                                            name="video"
                                                            accept="video/*"
                                                            onChange={handleVideoChange}
                                                        />
                                                    </div>



                                                </div>
                                                <div className='col-md-4 mt-2'>


                                                    <button type="submit" className='btn btn-success w-10'>
                                                        {isEditMode ? "Update" : "Save"}
                                                    </button>
                                                    <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                                                        setShowPartyForm(false);
                                                        setIsEditMode(false);
                                                        setNewProduct({
                                                            name: '',
                                                            parent: '',
                                                            address: "",
                                                            landmark: '',
                                                            city: "",
                                                            pin: '',
                                                            phone: '',
                                                            email: '',
                                                            priority: '',
                                                            type: '',
                                                            remark: '',
                                                            state: '',
                                                            region: '',
                                                            birth: '',
                                                            fax: '',
                                                            mobile: '',
                                                            pan: '',
                                                            gst: '',
                                                            profession: '',
                                                            source: '',
                                                            prodct: '',

                                                            phone_two: '',
                                                            phone_three: '',
                                                            profession_type: '',
                                                            contact_name: '',
                                                            contact_no: '',

                                                            currentAdd: '',
                                                            post_one: '',
                                                            post_two: '',
                                                            post_three: '',
                                                            customer_type: '',

                                                            cin: '',
                                                            msme: ''
                                                        })

                                                    }}>
                                                        Cancel
                                                    </button>
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                </>

                            )}



                            {!showPartyForm && (
                                <div className="col-md-12 d-grid d-flex justify-content-end">

                                    <button type="submit" className='btn btn-success w-10'>
                                        {isEditMode ? "Update" : "Save"}
                                    </button>
                                    <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                                        setShowAddForm(false);
                                        setIsEditMode(false);
                                        setNewProduct({
                                            partyId: "",
                                            name: "",
                                            type: "",
                                            holder_name: '',
                                            code: '',
                                            type_account: '',
                                            parent: '',
                                            op_bal: '',
                                            budget: '',
                                            days: ''
                                        })
                                    }}>
                                        Cancel
                                    </button>
                                </div>
                            )}

                        </form>
                    </div>
                )}

                {/* table */}
                <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                    <table className='table table-bordered table-striped table-hover text-center align-middle'>
                        <thead className='table-info'>
                            <tr>
                                <th scope='col'>SN</th>
                                <th scope='col'>Action</th>
                                <th scope='col'>Acc Holder Name</th>
                                <th scope='col'>Code</th>
                                <th scope='col'>Parent Name</th>
                                <th scope='col'> Account Type </th>

                            </tr>
                        </thead>
                        <tbody>

                            {filterAccount.length > 0 ? (
                                filterAccount.map((acc, idx) => {

                                    const parentObj = accountDetail.find(a => String(a.id) === String(acc.parent));
                                    const parentName = parentObj ? parentObj.holder_name : "-";

                                    return (
                                        <tr key={idx}>
                                            <td>{filterAccount.length - idx}</td>
                                            <td>
                                                <button
                                                    className="btn btn-info btn-sm text-white mx-1"
                                                    type="button"
                                                    onClick={() => handleView(acc)}
                                                >
                                                    <FaEye title='View Account' cursor='pointer' />
                                                </button>


                                                <button className='btn btn-primary mx-2' type='button'   onClick={() => {
    handleEdit(acc);

    setTimeout(() => {
      formRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  }}>
                                                    <MdEdit title='Edit' cursor='pointor' />
                                                </button>
                                                <button className='btn btn-danger' onClick={() => handleDeleteClick(acc.id)}>
                                                    <AiOutlineDelete size={20} title='Delete' cursor='pointor' />
                                                </button>
                                            </td>
                                            <td>{acc.holder_name}</td>
                                            <td>{acc.code}</td>
                                            <td>
                                                {accountDetail.find(a => String(a.id) === String(acc.parent))?.holder_name || '-'}
                                            </td>
                                            <td>{getAccountTypeName(acc.type_account)}</td>

                                        </tr>
                                    )
                                })
                            ) : (
                                <tr>
                                    <td colSpan="7">No data found.</td>
                                </tr>
                            )}

                        </tbody>
                    </table>
                </div>

                {showConfirm && (
                    <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-sm" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Confirm Delete</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setShowConfirm(false)}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <p>Are you sure you want to delete this item?</p>
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={() => setShowConfirm(false)}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-danger"
                                        onClick={confirmDelete}
                                    >
                                        OK
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

            

            </div>
        </div>
    )
}

export default Accounts